import React, { useState, useEffect } from 'react';
import { makeStyles, Grid, TextField, IconButton, Box, Typography, Paper } from '@material-ui/core';
import GreenButton from '../Shared/GreenButton';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslation } from 'react-i18next';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import clsx from 'clsx';
import { zoneDivisionsParameters } from '../../Config/constants'
import { fromNewDateFormatToDDMMYYYYHHmmssSlash } from '../../Helpers/dateHelper';

export default function ZoneDivisionPopupInput(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [tempZoneDivisions, setTempZoneDivisions] = useState([]);
    const [zoneDivisions, setZoneDivisions] = useState([]);
    const [zoneOrderLine, setZoneOrderLine] = useState(null);
    const [tabValue, setTabValue] = useState(0);
    const [newIndex, setNewIndex] = useState(0);

    useEffect(() => {
        if (zoneOrderLine === null && props.zoneDivisionsOrderLineId !== zoneOrderLine) {
            if (JSON.stringify(props.zoneDivisions) !== JSON.stringify(zoneDivisions)) {
                setTempZoneDivisions(props.zoneDivisions);
                setZoneDivisions(props.zoneDivisions);
                setZoneOrderLine(props.zoneDivisionsOrderLineId);
                setTabValue(props.zoneDivisions.length - 1);
                setNewIndex(props.zoneDivisions.length - 1);
            }
        }
    }, [props.zoneDivisions, props.zoneDivisionsOrderLineId]);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    function saveZoneDivisions() {
        setZoneDivisions(tempZoneDivisions);

        let zoneUpdateModel = { orderLineId: zoneOrderLine, zoneDivisionEntries: tempZoneDivisions.filter(x => x.entry === tabValue + 1) };
        dataService.saveZoneDivisions(zoneUpdateModel).catch((error) => { toast.error(error, { position: "top-center" }) });
        props.openZoneDivisionPopupInput(false);
        props.setReload(true);
    }

    const valueChanged = (e, zone, entry, field) => {
        e.preventDefault();
        var textvalue = e.target.value;
        //Deepclose the divisions
        let deepClonedDivisions = JSON.parse(JSON.stringify(tempZoneDivisions));
        if (deepClonedDivisions.find(x => x.entry === entry).zoneDivisions.some(x => x.zone === zone)) {
            var thisElement = deepClonedDivisions.find(x => x.entry === entry).zoneDivisions.find(x => x.zone === zone);
            switch (field) {
                //Switch between different input parameters
                case zoneDivisionsParameters.TEMPERATURE:
                    thisElement.temperature = '' + textvalue;
                    break;
                case zoneDivisionsParameters.LENGTH:
                    thisElement.length = '' + textvalue;
                    break;
                case zoneDivisionsParameters.WIDTH:
                    thisElement.width = '' + textvalue;
                    break;
                case zoneDivisionsParameters.WEIGHT:
                    thisElement.weight = '' + textvalue;
                    break;
                default:
                    break;
            }
            setTempZoneDivisions(deepClonedDivisions);
        }
    }

    function getWeightFromService(zone, entry) {

        dataService.getWeightForLineNumber(props.machineNumber).then((res) => {
            scaleWeightChanged(res, zone, entry);
        }).catch((error) => {
            toast.error(error, { position: "top-center" })
        });
    }

    function scaleWeightChanged(textvalue, zone, entry) {
        let tempzoneDivisions = [...tempZoneDivisions];
        let templength = parseFloat(tempzoneDivisions.find(x => x.entry === entry).zoneDivisions.find(x => x.zone === zone).length) || 0;
        let tempweight = parseFloat(tempzoneDivisions.find(x => x.entry === entry).zoneDivisions.find(x => x.zone === zone).width) || 0;

        let lengteFactor = 0.001;
        let breedteFactor = 0.001;
        let totalFactor = lengteFactor * breedteFactor;

        let calculatedWeight = 0;

        if ((templength * tempweight) > 0) {
            calculatedWeight = (textvalue * 1000) / (templength * tempweight * totalFactor);
        }

        tempzoneDivisions.find(x => x.entry === entry).zoneDivisions.find(x => x.zone === zone).weight = '' + calculatedWeight;
        setTempZoneDivisions(tempzoneDivisions)
    }


    return (
        <Dialog className={classes.dialogContainer}
            open={props.popupOpen}
            fullWidth
            maxWidth="xl"
            onInteractOutside={() => { console.log("suuuui") }}
        >
            <DialogTitle className={classes.dialogTitle}>
                {t('Zonale verdeling')}
            </DialogTitle>
            <DialogContent >
                <div className={classes.dialogContext}>
                    {
                        props.zoneDivisions[tabValue].insertedOn !== null && props.zoneDivisions[tabValue].insertedOn !== undefined ?
                            <Box className={classes.informationContainer}>
                                <Box className={classes.informationBlock} component={Paper}>
                                    <Typography className={classes.darkendBackground} variant="h6">{t('Aangemaakt door')}</Typography>
                                    <div className={classes.divider}></div>
                                    <Typography className={classes.wrapText} variant="h6">{props.zoneDivisions[tabValue].userName}</Typography>
                                </Box>
                                <Box className={classes.informationBlock} component={Paper}>
                                    <Typography className={classes.darkendBackground} variant="h6" component="h6">{t('Aangemaakt op')}</Typography>
                                    <div className={classes.divider}></div>
                                    <Typography className={classes.wrapText} variant="h6" component="h6">{fromNewDateFormatToDDMMYYYYHHmmssSlash(props.zoneDivisions[tabValue].insertedOn)}</Typography>
                                </Box>
                            </Box> : <React.Fragment></React.Fragment>}
                    {tempZoneDivisions !== null && tempZoneDivisions.length > 0 && props.zoneDivisions !== null && props.zoneDivisions !== undefined ?
                        <React.Fragment>
                            <AppBar position="static" className={classes.appBar}>
                                <Tabs value={tabValue} onChange={handleChange}>
                                    {zoneDivisions.map((zd) => (
                                        <Tab key={"tab_" + zd.entry} label={
                                            zd.newEntry ?
                                                <AddCircleOutlineIcon></AddCircleOutlineIcon>
                                                : <span >{zd.entry}</span>
                                        } title={zd.newEntry ? t('Nieuwe zonale verdeling') : t('Zonale verdeling') + " " + zd.entry} className={clsx({ [classes.activeTab]: tabValue === zd.entry - 1, [classes.notActiveTab]: tabValue !== zd.entry - 1, [classes.newTab]: zd.newEntry })} />
                                    ))
                                    }
                                </Tabs>
                            </AppBar>
                            <React.Fragment>
                                {props.zoneDivisions.map((zde, index) => {
                                    return (tabValue === zde.entry - 1 &&
                                        <Grid key={'Grid_Index_' + index} container spacing={3} className={classes.grid}>
                                            <TableContainer className={classes.paper}>
                                                <Table className={classes.table} aria-label="customized table">
                                                    <TableBody>
                                                        <TableRow key={"zone_" + zde.entry} className={classes.row} style={{ background: '#E6E8FE' }}>
                                                            <TableCell className={classes.boldNameCell}>
                                                                {t('zone')}
                                                            </TableCell>
                                                            {zde.zoneDivisions.map((zd, zdZoneIndex) => {
                                                                return <TableCell key={'tableCellZoneDiv_' + zde.entry + "_zd_" + zd.zone + "_zdZoneIndex_" + zdZoneIndex} className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                                    <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                        {zd.zone}
                                                                    </span>
                                                                </TableCell>
                                                            })}
                                                        </TableRow>
                                                        <TableRow key={"temperature_" + zde.entry} className={classes.row}>
                                                            <TableCell className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                                {t('temperature')}{t('(°C)')}
                                                            </TableCell>

                                                            {tempZoneDivisions.find(x => x.entry === zde.entry).zoneDivisions.map((zd, zdTempIndex) => {
                                                                return <TableCell key={`tabletemperatureCellZoneDiv_${zde.entry}_zd_${zd.zone}_zdTempIndex${zdTempIndex}`} className={classes.nameCell}>
                                                                    <TextField id={"outlined-search-temp-" + zde.entry + "*" + zd.zone} variant="standard" key={`temp_data_${zde.entry}_zd_${zd.zone}_zdIndex${zdTempIndex}`}
                                                                        value={tempZoneDivisions.find(x => x.entry === zde.entry).zoneDivisions.find(x => x.zone === zd.zone).temperature || ''}
                                                                        className={classes.textField}
                                                                        size="small" type="number" onChange={(e) => valueChanged(e, zd.zone, zde.entry, zoneDivisionsParameters.TEMPERATURE)} />
                                                                </TableCell>
                                                            })}
                                                        </TableRow>

                                                        <TableRow key={"length_" + zde.entry} className={classes.row}>
                                                            <TableCell className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                                {t('length')}{t('(mm)')}
                                                            </TableCell>
                                                            {zde.zoneDivisions.map((zd, zdLengthIndex) => {
                                                                return <TableCell key={`tablelengthCellZoneDiv_${zde.entry}_zd_${zd.zone}_zdLengthIndex${zdLengthIndex}`} className={classes.nameCell}>
                                                                    <TextField id={"outlined-search-length-" + zde.entry + "*" + zd.zone + "_zdIndex" + zdLengthIndex} variant="standard" key={`length_data_${zde.entry}_zd_${zd.zone}_zdLengthIndex${zdLengthIndex}`}
                                                                        value={tempZoneDivisions.find(x => x.entry === zde.entry).zoneDivisions.find(x => x.zone === zd.zone).length || ''}
                                                                        className={classes.textField}
                                                                        size="small" type="number" onChange={(e) => valueChanged(e, zd.zone, zde.entry, zoneDivisionsParameters.LENGTH)} />
                                                                </TableCell>
                                                            })}
                                                        </TableRow>
                                                        <TableRow key={"width_" + zde.entry} className={classes.row}>
                                                            <TableCell className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                                {t('width')}{t('(mm)')}
                                                            </TableCell>
                                                            {zde.zoneDivisions.map((zd, zdWidthIndex) => {
                                                                return <TableCell key={'tablewidthCellZoneDiv_' + zde.entry + "_zd_" + zd.zone + "_zdIndex" + zdWidthIndex} className={classes.nameCell}>
                                                                    <TextField id={"outlined-search-width-" + zde.entry + "*" + zd.zone + "_zdIndex" + zdWidthIndex} variant="standard" key={"width_data_" + zde.entry + "-" + zd.zone + "_zdIndex" + zdWidthIndex}
                                                                        value={tempZoneDivisions.find(x => x.entry === zde.entry).zoneDivisions.find(x => x.zone === zd.zone).width || ''} className={classes.textField}
                                                                        size="small" type="number" onChange={(e) => valueChanged(e, zd.zone, zde.entry, zoneDivisionsParameters.WIDTH)} />
                                                                </TableCell>
                                                            })}
                                                        </TableRow>
                                                        <TableRow key={"weight_" + zde.entry} className={classes.row}>
                                                            <TableCell className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                                {t('weight')}{t('(gr/m²)')}
                                                            </TableCell>
                                                            {zde.zoneDivisions.map((zd, zdWeightIndex) => {
                                                                return <TableCell key={'tableweightCellZoneDiv_' + zde.entry + "_zd_" + zd.zone + "_zdIndex" + zdWeightIndex} className={classes.nameCell}>
                                                                    <TextField id={"outlined-search-weight-" + zde.entry + "*" + zd.zone + "_zdIndex" + zdWeightIndex} variant="standard" key={"weight_data_" + zde.entry + "-" + zd.zone + "_zdIndex" + zdWeightIndex}
                                                                        value={tempZoneDivisions.find(x => x.entry === zde.entry).zoneDivisions.find(x => x.zone === zd.zone).weight || ''}
                                                                        className={classes.textField}
                                                                        size="small" type="number" onChange={(e) => valueChanged(e, zd.zone, zde.entry, zoneDivisionsParameters.WEIGHT)} />
                                                                </TableCell>
                                                            })}
                                                        </TableRow>
                                                        <TableRow key={"scale_" + zde.entry} className={classes.row}>
                                                            <TableCell className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                                {t('scale')}
                                                            </TableCell>
                                                            {zde.zoneDivisions.map((zd) => (
                                                                <TableCell key={'tableweightServiceCellZoneDiv_' + zde.entry + "_zd_" + zd.zone} className={classes.nameCell}>
                                                                    <IconButton aria-label="delete" color="primary" onClick={() => getWeightFromService(zd.zone, zde.entry)}>
                                                                        <svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" width="26.329" height="26.329" viewBox="0, 0, 400,400"><g id="svgg"><path id="path0" d="M56.793 69.618 C 47.692 74.912,61.843 107.560,78.819 120.435 C 95.038 132.735,99.731 133.581,151.758 133.588 L 193.750 133.594 193.750 148.047 L 193.750 162.500 146.996 162.500 C 102.226 162.500,100.186 162.562,98.913 163.969 C 97.067 166.008,43.750 322.053,43.750 325.415 C 43.750 331.868,27.188 331.250,200.000 331.250 C 372.984 331.250,356.250 331.884,356.250 325.326 C 356.250 321.994,292.870 167.029,290.374 164.258 L 288.790 162.500 247.520 162.500 L 206.250 162.500 206.250 148.078 L 206.250 133.655 250.195 133.407 C 299.643 133.127,297.668 133.337,310.547 127.000 C 328.998 117.921,342.113 100.121,345.227 79.932 C 346.511 71.604,344.886 68.750,338.859 68.750 C 334.946 68.750,333.273 71.121,331.823 78.722 C 328.132 98.079,312.780 114.221,293.391 119.133 C 286.385 120.908,113.615 120.908,106.609 119.133 C 87.266 114.232,71.867 98.100,68.210 78.906 C 66.435 69.588,62.436 66.335,56.793 69.618 M109.511 101.808 C 107.183 104.286,107.235 108.561,109.621 110.801 L 111.429 112.500 200.109 112.500 L 288.790 112.500 290.489 110.692 C 292.817 108.214,292.765 103.939,290.379 101.699 L 288.571 100.000 199.891 100.000 L 111.210 100.000 109.511 101.808 M309.988 245.508 C 325.934 284.287,339.213 316.631,339.496 317.383 C 339.985 318.682,333.004 318.750,199.693 318.750 C 122.518 318.750,59.375 318.657,59.375 318.543 C 59.375 318.355,107.334 178.268,108.183 175.977 C 108.469 175.203,126.504 175.000,194.770 175.000 L 280.996 175.000 309.988 245.508 M224.862 208.074 L 209.937 222.398 206.727 221.277 C 188.860 215.040,172.493 235.190,181.445 252.401 C 193.177 274.954,227.739 261.491,221.524 236.789 L 220.228 231.641 234.723 217.450 C 250.795 201.717,251.950 199.713,247.411 195.449 C 243.026 191.329,241.303 192.294,224.862 208.074 M204.622 235.123 C 210.521 238.132,209.941 246.508,203.627 249.504 C 194.262 253.948,186.073 243.458,193.281 236.250 C 196.441 233.091,199.954 232.741,204.622 235.123 " stroke="none" fillRule="evenodd"></path></g></svg>
                                                                    </IconButton>
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    )


                                })}
                            </React.Fragment>
                            <div className={classes.buttonContainer}>
                                <Button variant="outlined" className={classes.cancelButton} onClick={() => props.openZoneDivisionPopupInput(false)}>{t("CANCEL")}</Button>
                                <GreenButton text={newIndex === tabValue ? t("INSERT") : t("SAVE")} onClick={saveZoneDivisions}></GreenButton>
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment></React.Fragment>
                    }
                </div>
            </DialogContent>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        maxWidth: "1200px !important",
        maxHeight: "1000px !important",
        margin: "auto"
    },
    grid: {
        marginTop: '0px !important',
        marginBottom: '0px !important'

    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "20px",
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "20px"
    },
    nameCell: {
        border: "1px solid #ddd"
    },
    row: {
        border: "1px solid #ddd",
        padding: "0px",
    },
    boldNameCell: {
        border: "1px solid #ddd",
        fontWeight: "bold"
    }, cancelButton: {
        border: "1px solid " + FlagstoneTheme.palette.primary.main,
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        margin: "3px",
        width: "100px",
        marginBottom: "20px",
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            color: "white",

        },

    },
    appBar: {
        backgroundColor: "rgba(1,1,1,0)",
        boxShadow: "none",
        color: "#020100",
        "& > div > div > span": {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            height: "3px",
            width: "80px !important"
        },
        borderBottom: "1px solid #e3e0de",
        marginLeft: "30px",
        width: "97%",
        overflow: "visible"

    },
    activeTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: 'bold',
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    notActiveTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    paper: {
        width: "1200px !important"
    },
    textField: {
        width: "100%",
        height: "100%",
        '& input': {
            textAlign: "center",
            padding: "0px"
        }
    },
    buttonContainer: {
        width: "100%",
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: "20px"
    },
    informationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
    },
    informationBlock: {
        display: 'flex',
        flexDirection: 'column',
        borderRight: '1px solid #e3e0de',
        borderRadius: '5px',
    },
    divider: {
        height: '1px',
        width: '100%',
        backgroundColor: '#e3e0de',
    },
    darkendBackground: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "rgb(230, 232, 254)",
        padding: '10px',
    },
    wrapText: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        wordWrap: 'break-word',
        padding: '10px',
    },
}));
